/**
 * Base container component for header sections
 */
export class TrHeaderSet extends HTMLElement {
  static get observedAttributes() {
    return ['set-id'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    const style = document.createElement('style');
    style.textContent = `
      :host {
        display: flex;
        gap: 10px;
        align-items: center;
      }
    `;

    const container = document.createElement('div');
    container.classList.add('header-set');

    this.shadowRoot!.append(style, container);
  }

  attributeChangedCallback(name: string, _: string, newValue: string) {
    if (name === 'set-id' && this.shadowRoot) {
      this.shadowRoot.querySelector('div')?.setAttribute('id', newValue);
    }
  }
}

customElements.define('as-header-set', TrHeaderSet); 